import {useEffect, useState} from "react";
import {useVscServerClient} from "../kova/vscServerClient";
import {useVscContext} from "../components/content/VscReactContext";

async function fetchConfig(url:string) {
    const jsonResponse = await fetch(url);
    const unrealConfig = await jsonResponse.text();
    return unrealConfig;
}
export function useUnrealConfig() {
    const vscContext = useVscContext();
    const uri = vscContext.getHtmlContentUri("_config/unreal_config.txt");
    const [config, setConfig] = useState<null|string>(null);
    useEffect(() => {
        fetchConfig(uri).then(c => {
            setConfig(c);
        });
    }, []);
    return config;
}
